import { MarketingContactStatusType } from "@/types/graphql/partner.generated";

/** Подписи статусов контакта (чип в таблице контактов). */
export const CONTACT_STATUS_KEYS: Record<MarketingContactStatusType, string> = {
  [MarketingContactStatusType.SubscribedType]:
    "marketingContacts.status.SUBSCRIBED",
  [MarketingContactStatusType.UnsubscribedType]:
    "marketingContacts.status.UNSUBSCRIBED",
  [MarketingContactStatusType.SuppressedType]:
    "marketingContacts.status.SUPPRESSED",
};

/** Цвет чипа статуса: подписан зелёный, отписан серый, заблокирован красный. */
export const CONTACT_STATUS_COLORS: Record<
  MarketingContactStatusType,
  "success" | "default" | "error"
> = {
  [MarketingContactStatusType.SubscribedType]: "success",
  [MarketingContactStatusType.UnsubscribedType]: "default",
  [MarketingContactStatusType.SuppressedType]: "error",
};
